import type { KPIRequest } from "@/types/kpiTypes.ts"

export const ForHireKPIs: KPIRequest[] = [
  {
    $type: "basic",
    id: 400,
  },
  {
    $type: "basic",
    id: 401,
  },
  {
    $type: "basic",
    id: 430,
  },
  {
    $type: "basic",
    id: 500,
  },
  {
    $type: "basic",
    id: 440,
  },
  {
    $type: "calc",
    expression: "[440]*(1010/909.4)/8",
    name: "Fuel Consumption",
    unit: "MMBtu",
    preAggregate: true,
    aggFunction: "Sum",
  },
]
